'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3D',
  achievement: '達成',
  action: 'アクション',
  actions: 'アクション',
  add: '追加',
  'advanced-search': '詳細検索',
  aggregate: '集計',
  alarm: 'アラーム',
  alert: 'アラート',
  analytics: '分析',
  announcement: 'アナウンス',
  app: 'アプリケーション',
  archive: 'アーカイブ',
  article: '記事',
  ascend: '上昇',
  assistant: 'アシスタント',
  attachment: '添付ファイル',
  'bar-chart': '棒グラフ',
  blog: 'ブログ',
  book: '書籍',
  bookmark: 'ブックマーク',
  bundle: 'バンドル',
  calculator: '計算機',
  calendar: 'カレンダー',
  camera: 'カメラ',
  capacity: '容量',
  'caret-down': 'キャレット下へ',
  'caret-next': 'キャレット次へ',
  'caret-previous': 'キャレット前へ',
  'caret-up': 'キャレット上へ',
  catalog: 'カタログ',
  'chapter-add': 'チャプター追加',
  'chapter-next': 'チャプター次へ',
  'chapter-previous': 'チャプター前へ',
  chat: 'チャット',
  'checkbox-selected': 'チェックボックスオン',
  checkbox: 'チェックボックス',
  checkmark: 'チェックマーク',
  'circular-view': '円形ビュー',
  clipboard: 'クリップボード',
  clone: '複製',
  close: '閉じる',
  'cloud-computer': 'クラウドコンピューター',
  'cloud-download': 'クラウドダウンロード',
  'cloud-software': 'クラウドソフトウェア',
  'cloud-upload': 'クラウドアップロード',
  cloud: 'クラウド',
  cluster: 'クラスター',
  code: 'コード',
  'command-line': 'コマンドライン',
  compare: '比較',
  compasss: 'コンパス',
  compliance: 'コンプライアンス',
  'computer-personal': 'コンピューター個人用',
  configuration: '構成',
  connect: '接続',
  'contact-card': '連絡先カード',
  'contact-us': '連絡先',
  contract: '契約',
  copy: 'コピー',
  cube: '立方体',
  cubes: '立方体',
  cursor: 'カーソル',
  cut: '切り取り',
  cycle: 'サイクル',
  dashboard: 'ダッシュボード',
  database: 'データベース',
  defect: '不具合',
  deliver: '提供',
  deployment: 'デプロイメント',
  descend: '下降',
  desktop: 'デスクトップ',
  detach: 'デタッチ',
  directions: '方向',
  dislike: '嫌い',
  'divide-four': '4分割',
  'divide-right': '右を分割',
  'divide-three': '3分割',
  divide: '分割',
  'document-cloud': 'ドキュメントクラウド',
  'document-compress': 'ドキュメント圧縮',
  'document-conig': 'ドキュメント設定',
  'document-csv': 'ドキュメントCSV',
  'document-data': 'ドキュメントデータ',
  'document-download': 'ドキュメントのダウンロード',
  'document-excel': 'ドキュメントExcel',
  'document-executable': 'ドキュメント実行可能',
  'document-image': 'ドキュメント画像',
  'document-locked': 'ドキュメントロック済み',
  'document-missing': 'ドキュメント欠落',
  'document-notes': 'ドキュメントメモ',
  'document-outlook': 'ドキュメントOutlook',
  'document-pdf': 'ドキュメントPDF',
  'document-performance': 'ドキュメントパフォーマンス',
  'document-powerpoint': 'ドキュメントPowerpoint',
  'document-rtf': 'ドキュメントRTF',
  'document-sound': 'ドキュメントサウンド',
  'document-test': 'ドキュメントテスト',
  'document-text': 'ドキュメントテキスト',
  'document-threat': 'ドキュメント脅威',
  'document-time': 'ドキュメント時刻',
  'document-transfer': 'ドキュメント転送',
  'document-txt': 'ドキュメントtxt',
  'document-update': 'ドキュメント更新',
  'document-upload': 'ドキュメントアップロード',
  'document-user': 'ドキュメントユーザー',
  'document-verified': 'ドキュメント検証済み',
  'document-video': 'ドキュメントビデオ',
  'document-word': 'ドキュメントWord',
  document: 'ドキュメント',
  domain: 'ドメイン',
  down: '下へ',
  download: 'ダウンロード',
  drag: 'ドラッグ',
  'drive-cage': 'ドライブケージ',
  duplicate: '重複',
  edit: '編集',
  eject: '取り出し',
  expand: '拡大',
  fan: 'ファン',
  'fast-forward': '早送り',
  favorite: 'お気に入り',
  filter: 'フィルター',
  'first-aid': '救急',
  flag: 'フラグ',
  'folder-cycle': 'フォルダーサイクル',
  'folder-open': 'フォルダー開く',
  folder: 'フォルダー',
  gallery: 'ギャラリー',
  globe: '地球',
  grid: 'グリッド',
  group: 'グループ',
  grow: '成長',
  halt: '停止',
  help: 'ヘルプ',
  history: '履歴',
  home: 'ホーム',
  'host-maintenance': 'ホストメンテナンス',
  host: 'ホスト',
  image: 'イメージ',
  impact: '影響',
  'in-progress': '進行中',
  inbox: '受信トレイ',
  indicator: 'インジケーター',
  information: '情報',
  inherit: '継承',
  install: 'インストール',
  integration: '統合',
  iteration: '反復',
  java: 'Java',
  language: '言語',
  launch: '起動',
  license: 'ライセンス',
  like: '好き',
  'line-chart': '線グラフ',
  'link-bottom': 'リンク末尾',
  'link-down': 'リンク下へ',
  'link-next': 'リンク次へ',
  'link-previous': 'リンク前へ',
  'link-top': 'リンク先頭',
  'link-up': 'リンク上へ',
  link: 'リンク',
  'location-pin': '場所ピン',
  location: '場所',
  lock: 'ロック',
  login: 'ログイン',
  logout: 'ログアウト',
  mail: 'メール',
  manual: 'マニュアル',
  'map-location': 'マップ位置',
  map: 'マップ',
  menu: 'メニュー',
  microphone: 'マイクロフォン',
  monitor: 'モニター',
  more: 'その他',
  multiple: '複数',
  navigate: 'ナビゲート',
  'new-window': '新規ウィンドウ',
  new: '新規',
  next: '次へ',
  notes: 'メモ',
  notification: '通知',
  optimization: '最適化',
  organization: '組織',
  overlay: '重なり',
  overview: '概要',
  pan: 'パン',
  pause: '一時停止',
  'payment-google-wallet': '支払いGoogleウォレット',
  'payment-mastercard': '支払いMastercard',
  'payment-paypal': '支払いPaypal',
  'payment-square': '支払いSquare',
  'payment-visa': '支払いVisa',
  pin: 'ピン',
  plan: '計画',
  'platform-apple': 'プラットフォームApple',
  'platform-chrome': 'プラットフォームChrome',
  'platform-dropbox': 'プラットフォームDropbox',
  'platform-edge': 'プラットフォームEdge',
  'platform-firefox': 'プラットフォームFirefox',
  'platform-internet-explorer': 'プラットフォームInternet Explorer',
  'platform-skype': 'プラットフォームSkype',
  'platform-windows': 'プラットフォームWindows',
  play: '再生',
  power: '電源',
  previous: '前へ',
  print: '印刷',
  'quick-view': 'クイックビュー',
  'radial-selected': 'ラジアル選択',
  radial: 'ラジアル',
  refresh: '更新',
  resources: 'リソース',
  rewind: '巻き戻し',
  risk: 'リスク',
  rss: 'RSS',
  satellite: '衛星',
  'schedule-clone': 'スケジュール複製',
  'schedule-new': 'スケジュール新規',
  'schedule-play': 'スケジュール再生',
  schedule: 'スケジュール',
  scorecard: 'スコアカード',
  search: '検索',
  secure: 'セキュア',
  'select-left': '左を選択',
  select: '選択',
  'server-cluster': 'サーバークラスター',
  server: 'サーバー',
  servers: 'サーバー',
  'service-business': 'サービスビジネス',
  'service-start': 'サービス開始',
  share: '共有',
  'sheild-configure': 'シールド設定',
  shield: 'シールド',
  shift: 'シフト',
  'shop-basket': '買い物かご',
  'shop-cart': 'ショッピングカート',
  soa: 'SOA',
  'social-email': 'ソーシャル電子メール',
  'social-facebook': 'ソーシャルFacebook',
  'social-github': 'ソーシャルGithub',
  'social-google': 'ソーシャルGoogle',
  'social-instagram': 'ソーシャルInstagram',
  'social-linkedin': 'ソーシャルLinkedIn',
  'social-medium': 'ソーシャルMedium',
  'social-pinterest': 'ソーシャルPinterest',
  'social-reddit': 'ソーシャルReddit',
  'social-slack': 'ソーシャルSlack',
  'social-tumblr': 'ソーシャルTumblr',
  'social-twitter': 'ソーシャルTwitter',
  'social-vimeo': 'ソーシャルVimeo',
  'social-youtube': 'ソーシャルYoutube',
  sort: 'ソート',
  stakeholder: '関係者',
  'star-half': '星半分',
  star: '星',
  steps: 'ステップ',
  storage: 'ストレージ',
  'street-view': 'ストリートビュー',
  subtract: '減算',
  support: 'サポート',
  svg: 'SVG',
  sync: '同期',
  system: 'システム',
  'tab-next': 'タブ次へ',
  'tab-previous': 'タブ前へ',
  'tab-up': 'タブ上へ',
  'table-add': 'テーブル追加',
  table: 'テーブル',
  tag: 'タグ',
  target: 'ターゲット',
  task: 'タスク',
  template: 'テンプレート',
  'test-desktop': 'テストデスクトップ',
  test: 'テスト',
  'tesxt-wrap': 'テキスト折り返し',
  threats: '脅威',
  'three-d': '3D',
  ticket: 'チケット',
  tools: 'ツール',
  tooltip: 'ツールヒント',
  transaction: 'トランザクション',
  trash: 'ゴミ',
  tree: '木',
  trigger: 'トリガー',
  trophy: 'トロフィー',
  troubleshooting: 'トラブルシューティング',
  unlock: 'ロック解除',
  up: '上へ',
  update: '更新',
  upgrade: 'アップグレード',
  upload: 'アップロード',
  'user-add': 'ユーザー追加',
  'user-admin': 'ユーザー管理者',
  'user-expert': 'ユーザー専門家',
  'user-female': 'ユーザー女性',
  'user-manager': 'ユーザーマネージャー',
  'user-new': 'ユーザー新規',
  'user-police': 'ユーザー警察',
  'user-settings': 'ユーザー設定',
  'user-worker': 'ユーザー作業者',
  user: 'ユーザー',
  validation: '検証',
  video: 'ビデオ',
  view: 'ビュー',
  'virtual-machine': '仮想マシン',
  'vm-maintenance': 'VMメンテナンス',
  'volume-low': 'ボリューム小',
  'volume-mute': 'ボリュームミュート',
  volume: 'ボリューム',
  vulnerability: '脆弱性',
  waypoint: 'ウェイポイント',
  workshop: 'ワークショップ',
  'zoom-in': 'ズームイン'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/ja-JP.js
// module id = 126
// module chunks = 0